import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../../../../../environments/environment';

import { ISmartyAddress } from '@shared/models/address';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-sell',
  templateUrl: './sell.component.html',
  styleUrls: ['./sell.component.scss'],
})
export class SellComponent implements OnInit {
  protected step: 'verify-address' = 'verify-address';
  address?: ISmartyAddress;
  loading = false;
  utm_source: string | null = null;
  protected isMobile = false;

  constructor(private deviceService: DeviceDetectorService) {
    const url = new URL(window.location.href);
    this.utm_source = url.searchParams.get('utm_source');
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
  }

  selectAddress(address: ISmartyAddress) {
    this.address = address;
  }

  sendSelectedData() {
    if (!this.address) {
      return;
    }
    // this.loading = true;
    let params = new HttpParams()
      .set('city', this.address.city)
      .set('secondary', this.address.secondary)
      .set('state', this.address.state)
      .set('street_line', this.address.streetLine)
      .set('zipcode', this.address.zipcode);
    if (this.utm_source) {
      params = params.append('utm_source', this.utm_source);
    }

    parent.postMessage(
      { type: 'resizeIframe', height: this.isMobile ? 1180 : 1000 },
      '*'
    );
    document.location.href = `${
      environment.beIframe
    }/property-details?${params.toString()}`;

    // const iframeElement = parent.document.getElementById('sell_iframe');
    // console.log('iframeElement', iframeElement);
    // if (iframeElement) {
    //   iframeElement.style.height = this.isMobile ? '120px' : '1100px';
    //   document.location.href = `${environment.sellerUrl}?${params.toString()}`;
    //   // window.open(`${environment.sellerUrl}?${params.toString()}`, '_blank');
    // }
  }

  clearAddress() {
    this.address = undefined;
    this.step = 'verify-address';
  }
}
